import D2C_ProviderHosting from './Hosting'

class D2C_ProviderCustom extends D2C_ProviderHosting {
  id = 'custom'
  static objectType = 'providerType'
  static active = false
  static providerType = 'custom'
  static providerTitle = 'Custom'
}

export default D2C_ProviderCustom
